import { createContext, useContext, useState } from "react";
import { dict } from "@/i18n/dictionaries";

const LangContext = createContext(null);

const SUPPORTED = ["fr", "en", "es", "it", "pt", "de"];

function detectBrowserLang() {
  if (typeof window === "undefined" || !navigator) return "fr";
  const candidates = (navigator.languages || [navigator.language || "fr"]).map((l) => (l || "").slice(0, 2).toLowerCase());
  for (const c of candidates) {
    if (SUPPORTED.includes(c)) return c;
  }
  return "fr";
}

export function LangProvider({ children }) {
  const stored = typeof window !== "undefined" ? localStorage.getItem("lwt_lang") : null;
  const initial = stored && SUPPORTED.includes(stored) ? stored : detectBrowserLang();
  const [lang, setLangState] = useState(initial);
  const setLang = (l) => {
    setLangState(l);
    if (typeof window !== "undefined") localStorage.setItem("lwt_lang", l);
  };
  const t = (key) => {
    const d = dict[lang] || dict.fr;
    return d[key] || dict.fr[key] || key;
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
